import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage } from "./mobile-nav-menu-page";

export const MobileNavProductEveryone = ({
    productKey = "home"
}: {
    productKey?: ProductKeyTypes;
}) => {
    const intl = useIntl();

    function useProductsData(): Array<MobileNavCardProps> {
        return useMemo(() => {
            const productData: Array<MobileNavCardProps> = [
                {
                    key: "jira",
                    logo: "jira",
                    href: "/software/jira",
                    name: "Jira",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jira.description",
                            defaultMessage: "Flexible project management"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "confluence",
                    logo: "confluence",
                    href: "/software/confluence",
                    name: "Confluence",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.confluence.description",
                            defaultMessage: "Knowledge, all in one place"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "jsm",
                    logo: "jiraservicemanagement",
                    href: "/software/jira/service-management",
                    name: "Jira Service Management",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jsm.description",
                            defaultMessage: "High-velocity service delivery"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "rovo",
                    logo: "rovo",
                    href: "/software/rovo",
                    name: "Rovo",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.rovo.description",
                            defaultMessage: "Unlock enterprise knowledge"
                        })
                    ),
                    isNew: true
                },
                {
                    key: "jpd",
                    logo: "jiraproductdiscovery",
                    href: "/software/jira/product-discovery",
                    name: "Jira Product Discovery",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jpd.description",
                            defaultMessage: "Capture & prioritize ideas"
                        })
                    ),
                    isNew: true
                },
                {
                    key: "compass",
                    logo: "compass",
                    href: "/software/compass",
                    name: "Compass",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.compass.description",
                            defaultMessage: "Optimize software health"
                        })
                    ),
                    isNew: true
                },
                {
                    key: "guard",
                    logo: "guard",
                    href: "/software/access",
                    name: "Guard",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.guard.description",
                            defaultMessage: "Enhanced cloud security"
                        })
                    ),
                    isNew: true
                },
                {
                    key: "loom",
                    logo: "loom",
                    href: "//loom.com",
                    name: "Loom",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.loom.description",
                            defaultMessage: "Quick, async video updates"
                        })
                    ),
                    isNew: true
                }
            ];
            return productData;
        }, []);
    }

    const productsData = useProductsData();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.productseveryone.title",
                defaultMessage: "Featured Products"
            })}
            cards={productsData}
            productKey={productKey}
        />
    );
};
